
import React from "react";
import { Create, GetAllZones } from "adminApi/SlotApi/Slot.js";
import { validateForm } from "utils/validation";
import { SlotRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddSlotForm from "./components/AddSlotForm";
import fields from "../json/ZoneTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";

const AddSlot = ({ setRefetch, refetch }) => {
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        SlotRules
    );

    const { data: ZoneTypeOptions, loading } = useFetchAllData(GetAllZones);

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Create({ data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, SlotRules);
            setErrors(err);
            return err;
        },
        () => {
            setRefetch(!refetch);
            setValues(initialValues);
        },
        "Slot created successfully"
    );

    return (
        <>
            {(loadingSubmit || loading) && <Spinner isSpinner={true} />}
            <AddSlotForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Create Slot"
                ZoneTypeOptions={ZoneTypeOptions}
            />
        </>
    );
};

export default AddSlot;
